import { NameableResource, ResourceConfig } from '@hidat/huijs-resource';
import { FieldConfig, FieldDataTypes, Uuid } from '@hidat/huijs-common';
import { SplixerResourceInterface } from './splixer-resource.interface';

export const TenantConfig: ResourceConfig = new ResourceConfig(
  'Tenant',
  'tenants',
  false,
  true,
).addFields([
  new FieldConfig('id', FieldDataTypes.UID, false),
  new FieldConfig('status', FieldDataTypes.INTEGER),
  new FieldConfig('name').setRequired(true),
  new FieldConfig('address1'),
  new FieldConfig('address2'),
  new FieldConfig('city'),
  new FieldConfig('territory'),
  new FieldConfig('postal_code'),
  new FieldConfig('country'),
]);

export interface TenantInterface
  extends SplixerResourceInterface<Uuid>, NameableResource {
  address1: string | undefined;
  address2: string | undefined;
  city: string | undefined;
  territory: string | undefined;
  postalCode: string | undefined;
  country: string | undefined;
}
